import { apiGet, apiPost } from '../standardApi';

export async function apiPostClientCarteTpDownload (
  memberId,
  codeMember,
  memberType
) {
  const response = await apiGet(
    '/Clients/ClientCarteTpDownload',
    // JSON.stringify({
    //   memberId: memberId,
    //   codeMember: codeMember,
    //   memberType: memberType
    // }),
    'application/json'
  );
  return response;
}

export async function apiGenerateWalletPass(platform) {
  return await apiPost(
      "/clients/GenerateWalletPass",
      JSON.stringify({
        PlatformType: platform
      }),
      "application/json")
}
